import _slicedToArray from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { importCryptoKey } from './material_helpers';
import { getWebCryptoBackend } from '@aws-crypto/web-crypto-backend';
export function importForWebCryptoEncryptionMaterial(_x) {
  return _importForWebCryptoEncryptionMaterial.apply(this, arguments);
}

function _importForWebCryptoEncryptionMaterial() {
  _importForWebCryptoEncryptionMaterial = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(material) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(material.hasUnencryptedDataKey && material.hasCryptoKey)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", material);

          case 2:
            return _context.abrupt("return", importCryptoKeyToMaterial(material));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _importForWebCryptoEncryptionMaterial.apply(this, arguments);
}

export function importForWebCryptoDecryptionMaterial(_x2) {
  return _importForWebCryptoDecryptionMaterial.apply(this, arguments);
}

function _importForWebCryptoDecryptionMaterial() {
  _importForWebCryptoDecryptionMaterial = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(material) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!material.hasValidKey()) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", material);

          case 2:
            if (material.hasUnencryptedDataKey) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", material);

          case 4:
            _context2.next = 6;
            return importCryptoKeyToMaterial(material);

          case 6:
            return _context2.abrupt("return", _context2.sent.
            /* Now that a cryptoKey has been imported, the unencrypted data key can be zeroed.
             * this is safe, because one and only one EncryptedDataKey should be used to
             * set the unencrypted data key on the material,
             * and in the browser, all crypto operations are done with a CryptoKey
             */
            zeroUnencryptedDataKey());

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _importForWebCryptoDecryptionMaterial.apply(this, arguments);
}

export function importCryptoKeyToMaterial(_x3) {
  return _importCryptoKeyToMaterial.apply(this, arguments);
}

function _importCryptoKeyToMaterial() {
  _importCryptoKeyToMaterial = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(material) {
    var backend, cryptoKey, _material$keyringTrac, trace;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getWebCryptoBackend();

          case 2:
            backend = _context3.sent;
            _context3.next = 5;
            return importCryptoKey(backend, material);

          case 5:
            cryptoKey = _context3.sent;
            // The trace is only set when the material does not already have
            // an hasUnencryptedDataKey.  This is an implementation detail :(
            _material$keyringTrac = _slicedToArray(material.keyringTrace, 1), trace = _material$keyringTrac[0];
            return _context3.abrupt("return", material.setCryptoKey(cryptoKey, trace));

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _importCryptoKeyToMaterial.apply(this, arguments);
}